import api from './api';

const clubService = {
  // Routes publiques
  getAll: () => {
    return api.get('/clubs');
  },

  getBySlug: (slug) => {
    return api.get(`/clubs/${slug}`);
  },

  // Routes admin
  admin: {
    getAll: () => {
      return api.get('/admin/clubs');
    },

    getById: (id) => {
      return api.get(`/admin/clubs/${id}`);
    },

    create: (data) => {
      return api.post('/admin/clubs', data);
    },

    update: (id, data) => {
      return api.put(`/admin/clubs/${id}`, data);
    },

    delete: (id) => {
      return api.delete(`/admin/clubs/${id}`);
    },

    getStatistiques: () => {
      return api.get('/admin/clubs/statistiques');
    }
  }
};

export default clubService;

